var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{staticClass:"ButtonClose",attrs:{"large":"","text":"","to":_vm.to}},[_c('v-icon',{attrs:{"small":"","left":"","color":"grey lighten-4"}},[_vm._v("$mdiClose")]),_vm._v(" "+_vm._s(_vm.$t("close"))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }